// extracted by mini-css-extract-plugin
export default {"container":"_2qwz42gXo2nTKfgxXzsNQE","banner":"_31olu5e_2i5urM6w8QgNYJ","text":"_22U2Z9wW089HdPcXa-1wNk","button":"_9K9q9yrGYSKEoYeYrnvsU"};